import { Routes } from '@angular/router';

import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';

export const AppRoutes: Routes = [{
  path: '',
  component: AuthLayoutComponent,
  children: [{
    path: '',
    redirectTo: 'authentication/login/with-bg-image',
    pathMatch: 'full'
  }, {
    path: 'authentication',
    loadChildren: './authentication/authentication.module#AuthenticationModule'
  },
  {
    path: 'error',
    loadChildren: './error/error.module#ErrorModule'
  }, {
    path: 'landing',
    loadChildren: './landing/landing.module#LandingModule'
  }, {
    path: 'maintenance/offline-ui',
    loadChildren: './maintenance/offline-ui/offline-ui.module#OfflineUiModule'
  },]
}, {
  path: '',
  component: AdminLayoutComponent,
  children: [
    {
      path: '',
      redirectTo: 'dashboard/dashboard-default',
      pathMatch: 'full'
    }, {
      path: 'dashboard',
      loadChildren: './dashboard/dashboard.module#DashboardModule'
    }, {
      path: 'widget',
      loadChildren: './widget/widget.module#WidgetModule'
    }, {
      path: 'basic',
      loadChildren: './components/basic/basic.module#BasicModule'
    }, {
      path: 'advance',
      loadChildren: './components/advance/advance.module#AdvanceModule'
    }, {
      path: 'animations',
      loadChildren: './animations/animations.module#AnimationsModule'
    }, {
      path: 'forms',
      loadChildren: './components/forms/forms.module#FormsModule'
    }, {
      path: 'bootstrap-table',
      loadChildren: './components/tables/bootstrap-table/bootstrap-table.module#BootstrapTableModule',
    }, {
      path: 'data-table',
      loadChildren: './components/tables/data-table/data-table.module#DataTableModule',
    }, {
      path: 'map',
      loadChildren: './map/map.module#MapModule',
    }, {
      path: 'charts',
      loadChildren: './charts/charts.module#ChartsModule',
    }, {
      path: 'maintenance/error',
      loadChildren: './maintenance/error/error.module#ErrorModule'
    }, {
      path: 'maintenance/coming-soon',
      loadChildren: './maintenance/coming-soon/coming-soon.module#ComingSoonModule'
    }, {
      path: 'user',
      loadChildren: './user/user.module#UserModule'
    }, {
      path: 'backup',
      loadChildren: './backup/backup.module#BackupModule'
    }, {
      path: 'voucher',
      loadChildren: './voucher/voucher.module#VoucherModule'
    }
    , {
      path: 'accountancy',
      loadChildren: './accountancy/accountancy.module#AccountancyModule'
    }, {
      path: 'bankdari',
      loadChildren: './bankdari/bankdari.module#BankdariModule'
    }, {
      path: 'game',
      loadChildren: './game/game.module#GameModule'
    }, {
      path: 'game-help',
      loadChildren: './game-help/game-help.module#GameHelpModule'
    }, {
      path: 'game-name',
      loadChildren: './game-name/game-name.module#GameNameModule'
    }, {
      path: 'products',
      loadChildren: './products/products.module#ProductsModule'
    }, {
      path: 'products-groups',
      loadChildren: './products-groups/products-groups.module#ProductsGroupsModule'
    }, {
      path: 'game-type',
      loadChildren: './game-type/game-type.module#GameTypeModule'
    }, {
      path: 'league',
      loadChildren: './league/league.module#LeagueModule'
    }, {
      path: 'takhfif',
      loadChildren: './takhfif/takhfif.module#TakhfifModule'
    }, {
      path: 'questions-game',
      loadChildren: './questions-game/questions-game.module#QuestionsGameModule'
    }, {
      path: 'automatic-ending-job',
      loadChildren: './automatic-ending-job/automatic-ending-job.module#AutomaticEndingJobModule'
    }
    , {
      path: 'card',
      loadChildren: './card/card.module#CardModule'
    }, {
      path: 'namayandeh',
      loadChildren: './namayandeh/namayandeh.module#NamayandehModule'
    }, {
      path: 'setting',
      loadChildren: './setting/setting.module#SettingModule'
    }, {
      path: 'xml',
      loadChildren: './xml/xml.module#XmlModule'
    }, {
      path: 'copy',
      loadChildren: './copy/copy.module#CopyModule'
    }
    , {
      path: 'email',
      loadChildren: './email/email.module#EmailModule'
    }, {
      path: 'crm-contact',
      loadChildren: './components/crm-contact/crm-contact.module#CrmContactModule'
    }, {
      path: 'task',
      loadChildren: './components/task/task.module#TaskModule'
    }, {
      path: 'editor',
      loadChildren: './components/editor/editor.module#EditorModule'
    }, {
      path: 'invoice',
      loadChildren: './components/invoice/invoice.module#InvoiceModule'
    }, {
      path: 'file-upload',
      loadChildren: './components/file-upload/file-upload.module#FileUploadModule'
    }, {
      path: 'change-log',
      loadChildren: './change-log/change-log.module#ChangeLogModule'
    }, {
      path: 'simple-page',
      loadChildren: './simple-page/simple-page.module#SimplePageModule'
    }
  ]
}, {
  path: '**',
  redirectTo: 'error/404'
}];



// WEBPACK FOOTER //
// D:/Projects/Hb.Bet/ServerAPI/AdminAngular/src/app/app.routing.ts